export default "__VITE_ASSET__CBqVCiVQ__"